module.exports = __webpack_public_path__ + "assets/retina_RTrBy2SidePointsDetailed.e44798137a7e3e02552d10f9243ac259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_RTrBy2SidePointsDetailed.png
// module id = 707
// module chunks = 0